import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { AlertDialogService } from '../../components/modals/alert-dialog.service';
import { ConfirmDialogService } from '../../components/modals/confirm-dialog.service';
import { AuthService } from '../AuthService/auth.service';
import { GeneralHttpService } from '../general-http.service';
import { LoginResponse } from '../models/responses/login-response-model';
import { ProgressSpinnerService } from '../progress-spinner.service';
import { StorageKey } from '../storage/storage-model';
const { AUTH_TOKEN, REFRESH_TOKEN } = StorageKey;

@Injectable({
    providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {
    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    // tslint:disable-next-line: max-line-length
    constructor(private authService: AuthService, private generalHttpService: GeneralHttpService, private router: Router, private alertDialogService: AlertDialogService, private spinner: ProgressSpinnerService, private confirmDialogService: ConfirmDialogService, private snackBar: MatSnackBar) { }
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        let token: string = this.authService.getToken();
        if (token) {
            //gecıcı olarak konuldu.eger refreshToken a gıdıyorsa headera tokenı null gonderıyoruz.
            if (req.url.indexOf('Refresh') !== -1) {
                token = null;
            }
            req = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` }
            });
            this.spinner.show();
        }

        // if (token) {
        //     req = this.addToken(req, token);
        // }

        return next.handle(req).pipe(catchError(err => {
            if (err.status === 500) {
                this.alertDialogService.openAlertDialog('Sistemde Hata Oluştu.', null, 'Destek hattı ile iletişime geçebilirsiniz.');
            }
            if (err.status === 403) {
                this.alertDialogService.openAlertDialog('Bu işlem için yetkiniz bulunmamaktadır', null, 'Sistem yöneticiniz ile iletişime geçebilirsiniz.')
            }
            // if (err.status === 404) {
            //     this.alertDialogService.openAlertDialog('Bu işlem için yetkiniz bulunmamaktadır', null, 'Sistem yöneticiniz ile iletişime geçebilirsiniz.')
            // }
            // if (err.status === 400) {
            //     if (err.error.resultMessageCode.includes('InvalidOrMissingData')) {
            //         this.alertDialogService.openAlertDialog('Hatalı veri gönderimi', null, 'Destek hattı ile iletişime geçebilirsiniz.')
            //     }
            // }

            // if (err.status === 400) {
            //     this.alertDialogService.openAlertDialog('Sistemde Hata Oluştu', null, 'Destek hattı ile iletişime geçebilirsiniz.')
            // }
            if (err.status === 401) {
                if (err.error.resultMessageCode === 'MSG.Auth.ExpiredRefreshToken') {

                    this.snackBar.open(
                        'Oturum süreniz sona ermiştir.Giriş ekranına yönlendirildiniz',
                        'Kapat',
                        {
                            duration: 3000,
                        }
                    );

                    this.authService.logout();
                    req = null;
                }
                //suanlık undefined gelıyor ama normalde MSG.Auth.ExpiredAccessToken bu mesajı almam lazım
                if (err.error.resultMessageCode === undefined) {
                    const params = {
                        accesToken: token,
                        refreshToken: this.authService.getRefreshToken()
                    };
                    this.authService.refreshToken(params.accesToken, params.refreshToken).subscribe(res => {
                        if (res.isSuccessed) {
                            sessionStorage.setItem(AUTH_TOKEN, JSON.stringify(res.accessToken));
                            sessionStorage.setItem(REFRESH_TOKEN, JSON.stringify(res.refreshToken));
                            req = req.clone({
                                setHeaders: { Authorization: `Bearer ${res.accessToken}` },
                            });
                            //refresh token gıttıkten sonra yapması gereken req bılgısı req de var fakat sonuc bos donuyor.o sırada hangı requestı yapıyor ıse bos yapmıs oluyor.Onu duzeltmemız lazım
                            return next.handle(req).pipe(catchError(err => {
                                return throwError(err);
                            }))
                        }
                        else {
                            this.router.navigateByUrl('login');
                        }
                        // tslint:disable-next-line: no-shadowed-variable
                    }, err => {
                        console.log(err);
                    }
                    );
                }
                else {
                }
            }

            // if (err instanceof HttpErrorResponse && err.status === 401 && err.error.resultMessageCode === undefined) {
            //     const params = {
            //         accesToken: token,
            //         refreshToken: this.authService.getRefreshToken()
            //     };
            //     return this.handle401Error(req, next, params);
            // } else {
            //     return throwError(err);
            // }

            return throwError(err);
        }), finalize(() => {
            setTimeout(() => {
                this.spinner.hide();
            }, 400);

        }));
    }

    private addToken(request: HttpRequest<any>, token: string) {
        this.spinner.show();
        return request.clone({
            setHeaders: {
                'Authorization': `Bearer ${token}`
            }
        });

    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler, params?) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authService.refreshToken(params.accesToken, params.refreshToken).pipe(
                switchMap((token: any) => {
                    this.isRefreshing = false;
                    this.refreshTokenSubject.next(token.jwt);
                    return next.handle(this.addToken(request, token.jwt));
                }));

        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(jwt => {
                    return next.handle(this.addToken(request, jwt));
                }));
        }
    }
}



